import { Transaction } from 'types/rest/assetCatalogTypes';
import { action } from 'typesafe-actions';
import { SANDBOX_CLOSE, SANDBOX_OPEN, SANDBOX_SET_PENDING } from 'constants/action-types';

export type SandboxSetPendingAction = { type: typeof SANDBOX_SET_PENDING; payload: Transaction | null };
export type SandboxOpenAction = { type: typeof SANDBOX_OPEN; payload: Transaction };
export type SandboxCloseAction = { type: typeof SANDBOX_CLOSE };
export type SandboxAction = SandboxSetPendingAction | SandboxOpenAction | SandboxCloseAction;

export const setSandboxPending = (transaction: Transaction | null) => action(SANDBOX_SET_PENDING, transaction);
export const openSandbox = (transaction: Transaction) => action(SANDBOX_OPEN, transaction);
export const closeSandbox = () => action(SANDBOX_CLOSE);
